import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {SelectValueInterface} from '@interfaces/select-value.interface';
import {WorkingObjectsApiService} from '@api/working-objects.api.service';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {FormHelperService} from '@services/form-helper.service';

@Component({
    selector: 'app-element-form-order-selection',
    templateUrl: './element-form-order-selection.component.html',
})
export class ElementFormOrderSelectionComponent implements OnInit, OnDestroy {
    @Input() fbControl: FormControl;

    @Input() workingObjectId: number;

    public orders: SelectValueInterface[];

    constructor(
        private objectApi: WorkingObjectsApiService,
    ) {
    }

    ngOnInit() {
        this.fbControl.disable();
        this.objectApi.get({
            url: this.objectApi.getControlOrdersPath(this.workingObjectId)
        }).pipe(
            untilDestroyed(this)
        ).subscribe((orders) => {
            this.setOrders(orders || []);
        }, () => {
            this.setOrders([]);
        });
    }

    setOrders(value: SelectValueInterface[]) {
        this.orders = value || [];
    }

    ngOnDestroy(): void {
        FormHelperService.updateWithTouch(this.fbControl, '');
    }
}
